
























import { Component, Prop, Vue, Watch, Model } from "vue-property-decorator";
import { TabItem } from "@/types";
@Component
export default class ITab extends Vue {
  @Prop({
    type: Array,
    default: false,
    required: true
  })
  items!: TabItem[];

  @Model("model") value!: string;
  @Watch("value")
  watchValue(val: string) {
    this.onValueChange(val);
  }

  private left = 0;
  private index = 0;
  private width = 100;

  created() {
    this.onValueChange(this.value);
  }

  private onValueChange(value: string) {
    const findIndex = this.$utils.findIndexOf(
      this.items,
      el => el.name === value
    );
    if (findIndex !== null) {
      this.index = findIndex;
      this.left = (findIndex / this.items.length) * 100;
      this.width = (1 / this.items.length) * 100;
    }
    this.$emit("model", value);
    this.$emit("on-change", value);
  }
}
